/* @flow weak */
import Dialog from 'components/Dialog.jsx';
import LoadingIndicator from 'components/LoadingIndicator.jsx';
import * as React from 'react';

/**
 * ## Loading indicator that uses [Modal](/internal/components/Modal) behavior to take over the whole viewport.
 *
 *
 * ```example
 * <ModalTrigger modal={<LoadingModal />}>
 *   <Button>Show LoadingModal</Button>
 * </ModalTrigger>
 * ```
 */

const LoadingModal = ({ ...props }) => (
  <Dialog {...props} box={false} hideCloseButton className="LoadingModal">
    <LoadingIndicator align="center" />
  </Dialog>
);

export default LoadingModal;
